import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TablesModule } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/tables/tables.module';
import { HeaderComponent } from '../../../shared/components/header/header.component';
import { SharedModule } from '../../../shared/shared.module';
import { PermissionsModule } from '../permissions/permissions.module';
import { CprTableComponent } from './components/cprs-table/cpr-table.component';
import { CprRoutingModule } from './cpr-routing.module';
import { CprResolver } from './resolver/cpr.resolver';
import { CprTableScreenComponent } from './screens/table/cpr-table-screen.component';
import { CprsService } from './service/cprs.service';

@NgModule({
  declarations: [CprTableComponent, CprTableScreenComponent],
  providers: [CprsService, CprResolver],
  imports: [
    CommonModule,
    SharedModule,
    TablesModule,
    CprRoutingModule,
    PermissionsModule,
    HeaderComponent,
  ],
})
export class CprsModule {}
